import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ORG_USER_ROLES } from '../constants';

import { fetchFindDataProductRequest } from '../components/CMS/SystemAdmin/GlobalStates/DataAddProduct/actions';

export const DataAddProduct = () => {
     const dispatch = useDispatch();
     const dataAddProduct = useSelector((state) => state.admin.dataAddProduct);

     const fetchFindDataProduct = () => {
          if (!dataAddProduct) {
               dispatch(fetchFindDataProductRequest());
          }
     };

     useEffect(fetchFindDataProduct, []); // eslint-disable-line react-hooks/exhaustive-deps

     return <></>;
};

export const getOrganizationSystemAdmin = (data) => {
     data.users.forEach((user) => {
          user.orgRole = user.OrganizationUsers.role;
     });

     const ownerUser = data.users.find((user) => user.orgRole === ORG_USER_ROLES.OWNER);
     const ownerEmail = ownerUser?.email || '';

     return {
          ...data,
          ownerEmail,
     };
};

export const getUserAdmin = (user) => {
     const newOrganizations = user.organizations;

     const ownerNumber = newOrganizations.find((item) => item.OrganizationUsers.role === ORG_USER_ROLES.OWNER) ? 3 : 0;
     const managerNumber = newOrganizations.find((item) => item.OrganizationUsers.role === ORG_USER_ROLES.MANAGER) ? 2 : 0;
     const memberNumber = newOrganizations.find((item) => item.OrganizationUsers.role === ORG_USER_ROLES.USER) ? 1 : 0;
     const organizationsNames = newOrganizations.filter((org) => org.OrganizationUsers.role === ORG_USER_ROLES.OWNER).map((item) => item.name);

     const numberArr = [ownerNumber, managerNumber, memberNumber];
     const maxNumber = Math.max(...numberArr);
     let highestAccess = 'Member';

     switch (maxNumber) {
          case 3:
               highestAccess = 'Org Owner';
               break;
          case 2:
               highestAccess = 'Org Manager';
               break;
          case 1:
               highestAccess = 'Member';
               break;
          default:
               break;
     }

     return {
          ...user,
          organizationsName: organizationsNames.join(', '),
          highestAccess,
     };
};
